import { render } from "./GameSetupCoreFields.vue?vue&type=template&id=5d63d551&scoped=true"
import script from "./GameSetupCoreFields.vue?vue&type=script&lang=js"
export * from "./GameSetupCoreFields.vue?vue&type=script&lang=js"

import "./GameSetupCoreFields.vue?vue&type=style&index=0&id=5d63d551&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d63d551"]])

export default __exports__